import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaBook } from 'react-icons/fa';
import { testBtnOutline, testFocusRing } from '../test/testUiClasses';

/**
 * Same label as Ability Test; className overrides match each page’s UI.
 */
function TutorialInlineButton({ onClick, className, type = 'button', unstyled = false }) {
  const { t } = useTranslation();
  const alignment = 'inline-flex items-center gap-2';
  const defaults = `${testBtnOutline} ${testFocusRing} ${alignment}`;
  const base = unstyled && className
    ? `${alignment} ${className}`
    : className
      ? `${defaults} ${className}`
      : defaults;

  return (
    <button type={type} onClick={onClick} className={base}>
      <FaBook className="h-3.5 w-3.5 shrink-0" aria-hidden />
      {t('test.tutorial')}
    </button>
  );
}

export default TutorialInlineButton;
